
    export default 
    {
    "refresh_mask": {
        "title": "Aggiornamenti di Stato",
        "dec": "Aggiorna la pagina per aggiornare lo stato."
    }
}